<template>
  <div class="info-list-wrapper">
    <Subtitle>{{ title }}</Subtitle>

    <ul class="info-list">
      <li :key="text" v-for="{ target, callback, collbackTarget, text, type } in list" class="info-list-item">
        <button
          :id="collbackTarget"
          v-if="type === 'button'"
          @click="handleListItemClick(target, callback, collbackTarget)"
          class="info-list-button"
        >
          {{ text }}
        </button>
        <b-btn class="info-list-button" v-else :to="target">{{ text }}</b-btn>

        <!-- TODO удалить после обсуждения нового варианта отображения, задача FR-172 -->
        <!-- <main-tooltip :tooltipValue="text" :target="collbackTarget" v-if="Boolean(collbackTarget)" /> -->
      </li>
    </ul>
  </div>
</template>

<script>
import Subtitle from "./ui/Subtitle.vue";

export default {
  props: {
    title: {
      type: String,
      require: true,
    },
    list: {
      type: Array,
      require: true,
    },
  },
  components: {
    Subtitle,
  },
  methods: {
    handleListItemClick(target, callback, collbackTarget) {
      if (callback && collbackTarget) {
        callback(collbackTarget);
      }
      this.$bvModal.show(target);
    },
  },
};
</script>

<!-- scoped мешает задать стили тултипу -->
<style>
.info-list {
  margin-top: 16px;
  padding-left: 16px;
}
.info-list-item {
  margin-bottom: 8px;
}
.info-list-button {
  border: none;
  padding: 0;
  background-color: transparent;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-color);
  opacity: 1;
  transition: opacity 0.15s ease-out;
  text-align: left;
}
.info-list-button:last-of-type {
  margin-bottom: 0;
}

.info-list-button:hover,
.info-list-button:active,
.info-list-button:focus {
  opacity: 0.75;
  /* Приходится перебивать стили библиотеки */
  color: var(--primary-color) !important;
  background-color: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
